import { Pages, Roles } from '../../context/contexts/UserContext/permissionsTypes';
import useHasPermissions from '../../hooks/useHasPermissions';
import { LogicalRoute, LogicalRouteImportProps } from '../helpers/LogicalRoute';
import { usePricingModulesState } from '../../context/contexts/PricingModuleContext';
import ItdrPage from '../../modules/itdr/ItdrPage';
import { ITDRBlockedPage } from '../../modules/itdr/ITDRBlockPage/ITDRBlockedPage';
import { LAYOUT_TABS } from '@silverfort-nodelibs/common/utils/consts';

export const ItdrOnPremRouting = (props: LogicalRouteImportProps) => {
    const { isPageBlocked } = usePricingModulesState();
    const disabled = !useHasPermissions({ permission: Pages.RISK, role: Roles.VIEWER });
    const displayBlockPage = isPageBlocked(LAYOUT_TABS.ITDR.ID);

    return (
        <LogicalRoute
            {...props}
            component={ItdrPage}
            disabled={disabled}
            blockPageComponent={ITDRBlockedPage}
            displayBlockPage={displayBlockPage}
        />
    );
};
